import type { SupplierDistributionCoverageResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";

export const useSupplierDistributionCoverage = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  return useQuery({
    gcTime: 60 * 60 * 1000,
    queryKey: [user?.uid, business?.id, "supplier-distribution-coverage"],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "supplier-distribution-preview/coverage",
      }).then(
        (response) =>
          apiV2AssertResponse<SupplierDistributionCoverageResponseType["data"]>(
            response,
          ).data,
      ),
    ...getDefaultQueryOptionsV2<
      SupplierDistributionCoverageResponseType["data"]
    >({
      context: { scope: "supplier", user, business },
      options: { staleTime: 15 * 60 * 1000 },
    }),
  });
};
